// extracted by mini-css-extract-plugin
export default {"mic_animation":"MicAnimation_mic_animation__LSmmo","mic":"MicAnimation_mic__MaIVL","show-tag":"MicAnimation_show-tag__9blkH"};